import script from "./UserSwitchModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserSwitchModal.vue?vue&type=script&lang=ts&setup=true"

import "./UserSwitchModal.vue?vue&type=style&index=0&id=470268e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470268e4"]])

export default __exports__